import { render, staticRenderFns } from "./BsiMultiChanges.vue?vue&type=template&id=fc47e374&scoped=true&"
import script from "./BsiMultiChanges.vue?vue&type=script&lang=js&"
export * from "./BsiMultiChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc47e374",
  null
  
)

export default component.exports